import './header.scss';
import '../linkcoloractive.scss';
import React, { useEffect, useState } from 'react';
import { Storage, translate } from 'react-jhipster';
import LoadingBar from 'react-redux-loading-bar';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import moment from 'moment/moment';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogProps, DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import { AUTHORITIES } from 'app/config/constants';
import { TabSessionManager } from 'app/shared/util/tab-session-manager';
import {
  getEntitiesByUserId as getNotificationByUserId,
  getCurrentEntitiesByUserId as getCurrentNotifiicationsByUserId,
  updateEntity as updateNotification,
  getBursaTimeOutNotiByUserId,
} from 'app/entities/notification-record/notification-record.reducer';
import HeaderNavBar from './header-navbar';

export interface IHeaderProps {
  isAuthenticated: boolean;
  currentLocale: string;
  account: any;
}

const Header = (props: IHeaderProps) => {
  const account = props.account && Object.keys(props.account).length > 0 ? props.account : Storage.session.get('account');
  const notification = useAppSelector(state => state.notificationRecord.entities);
  const currentNotification = useAppSelector(state => state.notificationRecord.currentMonthEntities);
  const [from, setFrom] = useState<Date | null>(moment().subtract(30, 'day').toDate());
  const [to, setTo] = useState<Date | null>(new Date());
  const dismissedNotification = useAppSelector(state => state.notificationRecord.updateSuccess);
  const [maxWidth, setMaxWidth] = useState<DialogProps['maxWidth']>('sm');
  const [openBursaTimeOut, setOpenBursaTimeOut] = useState(false);
  const [failedQuotationIdText, setFailedQuotationIdText] = useState('');
  const [dateTextForFailedQuotation, setDateTextForFailedQuotation] = useState('');

  const dispatch = useAppDispatch();

  const handleBursaTimeOutNotiToClose = () => {
    setOpenBursaTimeOut(false);
  };

  useEffect(() => {
    // Initialize tab
    TabSessionManager.initializeTab();
    TabSessionManager.syncToken();

    // Start heartbeat
    TabSessionManager.startHeartbeat();

    if (account?.login && localStorage.getItem('RememberMe') === '0') {
      // Listener for Tab/Window close
      const handleBeforeUnload = e => {
        TabSessionManager.onTabClose();
      };

      // Listener for page visibility
      const handleVisibilityChange = () => {
        TabSessionManager.handleVisibilityChange();
      };

      window.addEventListener('beforeunload', handleBeforeUnload);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      // Cleanup
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        TabSessionManager.stopHeartbeat();
      };
    }

    // Cleanup heartbeat even if remember me is checked
    return () => {
      TabSessionManager.stopHeartbeat();
    };
  }, [account?.login]);

  useEffect(() => {
    if (dismissedNotification) {
      if (moment(from).format('yyyy/MM/DD') !== moment(moment().subtract(30, 'day').toDate()).format('yyyy/MM/DD')) {
        dispatch(
          getNotificationByUserId({
            userId: account?.id,
            fromDate: moment(from).format('yyyy/MM/DD'),
            toDate: moment(to).add(1, 'day').format('yyyy/MM/DD'),
          })
        );
        dispatch(
          getCurrentNotifiicationsByUserId({
            userId: account?.id,
            fromDate: moment(moment().subtract(30, 'day').toDate()).format('yyyy/MM/DD'),
            toDate: moment(new Date()).add(1, 'day').format('yyyy/MM/DD'),
          })
        );
      } else {
        dispatch(
          getCurrentNotifiicationsByUserId({
            userId: account?.id,
            fromDate: moment(moment().subtract(30, 'day').toDate()).format('yyyy/MM/DD'),
            toDate: moment(new Date()).add(1, 'day').format('yyyy/MM/DD'),
          })
        );
      }
    }
  }, [dismissedNotification]);

  useEffect(() => {
    if (account?.id !== undefined) {
      dispatch(
        getCurrentNotifiicationsByUserId({
          userId: account?.id,
          fromDate: moment(from).format('yyyy/MM/DD'),
          toDate: moment(to).add(1, 'day').format('yyyy/MM/DD'),
        })
      );
      if (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) || account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER)) {
        dispatch(getBursaTimeOutNotiByUserId(account?.id)).then(res => {
          if (res.payload['data']?.id !== undefined && res.payload['data']?.id !== 0) {
            setFailedQuotationIdText(translate('home.failedQuotationId') + '' + res.payload['data']?.quotationId);
            setDateTextForFailedQuotation(
              translate('home.failedDate') + '' + moment(res.payload['data']?.createdDate).format('YYYY/MM/DD')
            );
            setOpenBursaTimeOut(true);

            const entity = {
              ...res.payload['data'],
              dismissed: true,
            };
            dispatch(updateNotification(entity));
          }
        });
      }

      setInterval(() => {
        dispatch(
          getCurrentNotifiicationsByUserId({
            userId: account?.id,
            fromDate: moment(from).format('yyyy/MM/DD'),
            toDate: moment(to).add(1, 'day').format('yyyy/MM/DD'),
          })
        );

        if (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) || account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER)) {
          dispatch(getBursaTimeOutNotiByUserId(account?.id)).then(res => {
            if (res.payload['data']?.id !== undefined && res.payload['data']?.id !== 0) {
              setFailedQuotationIdText(translate('home.failedQuotationId') + '' + res.payload['data']?.quotationId);
              setDateTextForFailedQuotation(
                translate('home.failedDate') + '' + moment(res.payload['data']?.createdDate).format('YYYY/MM/DD')
              );
              setOpenBursaTimeOut(true);

              const entity = {
                ...res.payload['data'],
                dismissed: true,
              };
              dispatch(updateNotification(entity));
            }
          });
        }
      }, 30000);
    }
  }, []);

  if (!account || Object.keys(account).length === 0 || !props.isAuthenticated) {
    return <></>;
  } else {
    return (
      <div id="app-header">
        <LoadingBar className="loading-bar" />
        <HeaderNavBar
          isAuthenticated={props.isAuthenticated}
          currentLocale={props.currentLocale}
          account={account}
          notification={notification}
          currentNotification={currentNotification}
        />
        <Dialog open={openBursaTimeOut} onClose={handleBursaTimeOutNotiToClose} maxWidth={maxWidth}>
          <DialogTitle></DialogTitle>
          <DialogContent>
            <DialogContentText>
              {translate('home.bursaError')}
              <br />
              {failedQuotationIdText}
              <br />
              {dateTextForFailedQuotation}
              <br />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleBursaTimeOutNotiToClose}>{translate('comexApp.quotation.okButton')}</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
};

export default Header;
